import clientInformation, { getClientItem } from '../login/ClientInfo';
import { RequestEWalletPayout, GetPayoutFee } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';

export const PayoutR4ConectaMethods = () => {
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(getClientItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID.toLowerCase() === id.toLowerCase(); })[0]);
    const navigate = useNavigate();
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');
    const bancos = [
        { codigo: "0001", nombre: "Banco Central de Venezuela" },
        { codigo: "0102", nombre: "Banco de Venezuela, S.A. Banco Universal" },
        { codigo: "0104", nombre: "Banco Venezolano de Cr\u00e9dito, S.A Banco Universal" },
        { codigo: "0105", nombre: "Banco Mercantil C.A., Banco Universal" },
        { codigo: "0108", nombre: "Banco Provincial, S.A. Banco Universal" },
        { codigo: "0114", nombre: "Banco del Caribe C.A., Banco Universal" },
        { codigo: "0115", nombre: "Banco Exterior C.A., Banco Universal" },
        { codigo: "0128", nombre: "Banco Caron\u00ed C.A., Banco Universal" },
        { codigo: "0134", nombre: "Banesco Banco Universal, C.A." },
        { codigo: "0137", nombre: "Banco Sofitasa Banco Universal, C.A." },
        { codigo: "0138", nombre: "Banco Plaza, Banco Universal" },
        { codigo: "0146", nombre: "Banco de la Gente Emprendedora C.A." },
        { codigo: "0151", nombre: "Banco Fondo Com\u00fan, C.A Banco Universal" },
        { codigo: "0156", nombre: "100% Banco, Banco Comercial, C.A" },
        { codigo: "0157", nombre: "Delsur, Banco Universal C.A." },
        { codigo: "0163", nombre: "Banco del Tesoro C.A., Banco Universal" },
        { codigo: "0166", nombre: "Banco Agr\u00edcola de Venezuela C.A., Banco Universal" },
        { codigo: "0168", nombre: "Bancrecer S.A., Banco Microfinanciero" },
        { codigo: "0169", nombre: "R4, Banco Microfinanciero, C.A." },
        { codigo: "0171", nombre: "Banco Activo C.A., Banco Universal" },
        { codigo: "0172", nombre: "Bancamiga Banco Universal, C.A." },
        { codigo: "0173", nombre: "Banco Internacional de Desarrollo C.A., Banco Universal" },
        { codigo: "0174", nombre: "Banplus Banco Universal, C.A." },
        { codigo: "0175", nombre: "Banco Digital de los Trabajadores, Banco Universal C.A." },
        { codigo: "0177", nombre: "Banco de la Fuerza Armada Nacional Bolivariana, B.U." },
        { codigo: "0178", nombre: "N58 Banco Digital, Banco Microfinanciero" },
        { codigo: "0191", nombre: "Banco Nacional de Cr\u00e9dito C.A., Banco Universal" },
        { codigo: "0601", nombre: "Instituto Municipal de Cr\u00e9dito Popular" },
    ];

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(
           
        )
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }

        ChangeWalletAddressFormat(arrayPayouts?.ImageName)

    }, [])

    async function ChangeWalletAddressFormat(ImageName) {
        const walletInputs = document.getElementsByName("walletaddress");

        if (!walletInputs || walletInputs.length === 0) return;

        const walletInput = walletInputs[0]; // Use the first matching input

        switch (ImageName.toLowerCase()) {
            case "cashapp":
                walletInput.placeholder = "Must start with $ sign";
                break;
            case "venmo":
                walletInput.placeholder = "Must start with @ sign";
                break;
            case "applepay":
                walletInput.placeholder = "Valid phone number format +1234567890";
                break;
            case "zelle":
            case "paypal":
                walletInput.placeholder = "Valid email address";
                break;
            case "tylt":
                walletInput.placeholder = "CPF / PIX (TaxID)";
                break;
            default:
                walletInput.placeholder = "Enter wallet address";
                break;
        }
    }

    async function doRequestEWalletPayout(Amount, banco, cedula) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) <= parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": getClientItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": "VES",
                "ProcessorName": arrayPayouts?.PayoutID,
                "EWalletID": banco + "|" + cedula,
                "SecureID": "",
                "IPv4Address": clientInfo.IPAddress,
                "Comments": "Payout - R4Conecta"
            };
            
            await RequestEWalletPayout(PayoutData).then(function (response) {

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.Status,
                        ProcessorName: arrayPayouts?.PayoutID
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Withdrawal Status', response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert('Withdrawal Status', response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Withdrawal Status', response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert('Withdrawal Status', response.Authentication.HtmlResponse, 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert('Withdrawal Status', error.response.data.Authentication.HtmlResponse, 'error');
                    //Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen('Withdrawal Status', 'amount not permitted, please check your withdrawal balance', 'warning');
            else
                Alerts.ShowAlert('Withdrawal Status', 'amount not permitted, please check your withdrawal balance', 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, banco, cedula } = Object.fromEntries(data.entries());

            if (amount !== '' && banco !== '' && cedula !== '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestEWalletPayout(amount, banco, cedula);
                setIsProcessing(false);
            } else if (amount === '') {
                Alerts.ShowAlert('Warning', 'Monto requerido', 'warning');
            } else if (banco === '') {
                Alerts.ShowAlert('Warning', 'Banco requerido', 'warning');
            } else if (cedula === '') {
                Alerts.ShowAlert('Warning', 'C\u00e9dula requerida', 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/r4conecta.svg"} />  <span className="payout-title">Retiro usando R4Conecta </span>
                    </span>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-12 mb-3">
                        <label htmlFor="banco" className="form-label fw-semibold">
                            Banco
                        </label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="fas fa-university"></i>
                            </span>
                            <select
                                className="form-select"
                                id="banco"
                                aria-describedby="lblBanco"
                                name="banco"
                                required
                                defaultValue=""
                            >
                                <option value="" disabled>Seleccione una opci&oacute;n</option>
                                {bancos.map((banco) => (
                                    <option key={banco.codigo} value={banco.codigo}>
                                        {banco.codigo} - {banco.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="invalid-feedback">
                            Seleccione un banco.
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 mb-3">
                        <label htmlFor="cedula" className="form-label fw-semibold">
                            C&eacute;dula
                        </label>
                        <input type="text" className="form-control" id="cedula" aria-describedby="lblCedula" placeholder="Cedula" name="cedula" value={getClientItem('SSN')} required="required" readOnly />
                    </div>
                    <div className="col-md-6 col-sm-12 mb-3">
                        <label htmlFor="telefono" className="form-label fw-semibold">
                            Tel&eacute;fono
                        </label>
                        <input type="text" className="form-control" id="telefono" aria-describedby="lblTelefono" placeholder="Telefono" name="telefono" value={getClientItem('Phone')} required="required" readOnly />
                    </div>
                    <div className="col-md-6 col-sm-12 m3">
                        <label htmlFor="amount" className="form-label fw-semibold">
                            Monto
                        </label>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value="VES">
                                        <option value="" className="">Currency</option>
                                        <option selected value="VES">Bs</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Monto" max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0}/>
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                            L&iacute;mite de retiro: M&iacute;nimo {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} Bs M&aacute;ximo {arrayPayouts?.MaxPayout === 0 ? 'Sin limite' : arrayPayouts?.MaxPayout + ' Bs'}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/*<div className="col-md-6 col-sm-12 mb-3">*/}
                    {/*    <textarea rows="3" cols="75" className="form-control" id="comments" aria-describedby="lblcomments" placeholder="Comments" name="comments" required="required" />*/}
                    {/*</div>*/}
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>BACK</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">SUBMIT</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}